import { Button } from "@mui/material";

import AlertConfirm from "commons/ui/alert/AlertConfirm";
import DataTableSimple from "commons/ui/datatable/DataTableSimple";
import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import Paper from "commons/ui/Paper";

import ProjectsTableFilters from "components/subComponents/ProjectsTableFilters";

import useProjectsList from "hooks/list/useProjectsList";

function ElencoProgetti() {
    const projectsListHook = useProjectsList();

    const { navigateToNewProject, alertConfirmHook, dataTableHook } = projectsListHook;

    return (
        <GridColumn>
            <AlertConfirm alertConfirmHook={alertConfirmHook} />

            <Paper className={"table-with-filters"}>
                <ProjectsTableFilters projectsListHook={projectsListHook} />

                <DataTableSimple dataTableHook={dataTableHook} dontUsePaper />
            </Paper>

            <GridRow justifyContent={"right"}>
                <GridItem className={"button-under-paper"}>
                    <Button variant={"contained"} onClick={navigateToNewProject}>
                        Nuovo progetto
                    </Button>
                </GridItem>
            </GridRow>
        </GridColumn>
    );
}

export default ElencoProgetti;
